module.exports = __webpack_public_path__ + "media/three-coin2.82b4cb30.mp3";